import { Button } from 'src/components/Button/Button.component';
import { ButtonContainer } from 'src/components/Button/style/Button.style';
import InputField from 'src/components/InputField/InputField.component';
import Loader from 'src/components/Loader/Loader.component';
import PayByLinkHeader from 'src/components/PayByLinkHeader/PayByLinkHeader.component';
import SubmitButton from 'src/components/SubmitButton/SubmitButton.component';
import Translate from 'src/components/Translate/Translate.component';
import { FormProvider, useForm } from 'react-hook-form';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { RoutePath } from 'src/routers/routers.config';
import { searchCompanyInfoMethodApi } from 'src/services/orderLink/orderLink.request';
import { useRegistrationStore } from 'src/store/store';
import { H4 } from 'src/style-utils/typographic';
import { FlowContainer } from 'src/style/Container.style';
import { IDs } from 'src/utils/config/ids';
import toTitleCase from 'src/utils/functions/formatString';
import { formConfigStepName, nameField } from './RegistrationStepName.helpers';
import { StyleSheetManager } from 'styled-components';
import { shouldForwardProp } from 'src/style-utils/functions';

function RegistrationStepName() {
  const navigate = useNavigate();
  const { country, setValues, name, validation } = useRegistrationStore(
    (state) => state,
  );

  const { mutate, isPending } = useMutation({
    mutationFn: searchCompanyInfoMethodApi,
    onSuccess: (res) => {
      if (res.data.ResultSet.Result === 'not_found') {
        navigate(RoutePath.ThankyouPageError + RoutePath.fiscalCodeMatchError);
        return;
      }
      const {
        FiscalCode,
        PostalCode,
        Address,
        Name,
        VatCode,
        SearchId,
        Country,
      } = res.data.ResultSet.Items[0];
      const values = {
        codiceFiscale: FiscalCode,
        postalCode: PostalCode,
        address: toTitleCase(Address),
        name: toTitleCase(Name),
        vatCode: VatCode,
        companySearchId: SearchId,
        country: Country.toUpperCase(),
        results: res.data?.ResultSet?.Items,
      };
      setValues(values);
      navigate(RoutePath.registrationMerchant + RoutePath.checkDataStep);
    },
    onError: () => {
      navigate(RoutePath.oops);
    },
  });
  const onSubmit = (data: any) => {
    mutate({
      country,
      name: data[nameField],
    });
  };
  const { initialValues, resolver } = formConfigStepName(name);
  const methods = useForm({
    defaultValues: initialValues,
    resolver,
    mode: 'onChange',
  });
  if (isPending) {
    return <Loader overlayViewMode="fullscreen" active viewMode="fluid" />;
  }
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <PayByLinkHeader
        stepBack
        step={2}
        stepMax={9}
        title="lbl.searchYourCompany"
      />
      <FlowContainer>
        <H4 light>
          <Translate id="text.searchYourCompany" />
        </H4>
        <div className="content">
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
              <InputField
                label="lbl.agencyCustomerNameRequired"
                name={nameField}
              />
              <ButtonContainer>
                <SubmitButton
                  variant="Primary"
                  minWidth="100%"
                  i18n={true}
                  translatedText="lbl.search"
                  id={IDs.btnConfirm}
                />
                {validation?.vatNumber.isAvailable && (
                  <Button
                    type="button"
                    variant="Tertiary"
                    minWidth="100%"
                    i18n={true}
                    translatedText="lbl.searchByVAT"
                    id={IDs.btnDecline}
                    onClick={() =>
                      navigate(
                        RoutePath.registrationMerchant + RoutePath.stepVAT,
                      )
                    }
                  />
                )}
              </ButtonContainer>
            </form>
          </FormProvider>
        </div>
      </FlowContainer>
    </StyleSheetManager>
  );
}

export default RegistrationStepName;
